import clsx from 'clsx'
import { colorBack } from './Utility'
//+++++++++++++++++++++++++++++++++++

//* font-weight numeric & named value

//* 100 Thin
//* 200 Extra Light
//* 300 Light
//* 400 Normal
//* 500 Medium
//* 600 Semi Bold
//* 700 Bold
//* 800 Extra Bold
//* 900 Ultra Bold

//++++++++++++++++++++++++++++++++++

//* font-size Heading giude

//* h1: 2.5rem
//* h2: 2.2rem
//* h3: 1.7rem
//* h4: 1.4rem
//* h5: 1.2rem
//* h6: 1.05rem

//++++++++++++++++++++++++++++++++++

//* line-height guide

//* default: 1.167
//* paragraph: 1.5

//++++++++++++++++++++++++++++++++++

//                            css={(theme) => ({color: theme.colors.medGray})}

function Typography({
    type = 't',
    children,
    color,
    fontWeight,
    lineHeight,
    align = 'start',
    lineClamp,
    className,
    hoverColor,
    fontSize,
    transform = 'none',
    style
}) {
    const fontWeightSwitch = (weightName) => {
        switch (weightName) {
            case 'Thin':
                return '100'
            case 'Extra Light':
                return '200'
            case 'Light':
                return '300'
            case 'Normal':
                return '400'
            case 'Medium':
                return '500'
            case 'Semi Bold':
                return '600'
            case 'Bold':
                return '700'
            case 'Extra Bold':
                return '800'
            case 'Ultra Bold':
                return '900'
        }
    }

    /* eslint-disable */
    const typoCss = (theme) => {
        const themeTypography = theme.typography?.[type] ?? theme.typography?.['t'] ?? {}
        return `
            margin-bottom: 0.35rem;
            font-size: ${fontSize || themeTypography.fontSize};
            line-height: ${lineHeight || themeTypography.lineHeight};
            font-weight: ${fontWeightSwitch(fontWeight) || themeTypography.fontWeight
            };
            text-align: ${align};
            color: ${colorBack(color) || theme.colors?.[color] || theme.colors?.text
            };
            overflow: ${lineClamp ? 'hidden' : ''};
            display: ${lineClamp ? '-webkit-box' : ''};
            -webkit-box-orient: ${lineClamp ? 'vertical' : ''};
            -webkit-line-clamp: ${lineClamp ? lineClamp : ''};
            ${hoverColor &&
            `&:hover {
                    color: ${theme.colors?.[hoverColor]};
                }`
            };
            text-transform: ${transform};
            ${style};

            @media (max-width: 1024px) {
                overflow: visible;
                display: block;
            }
        `
    }
    const typoCss2 = (theme) => {
        const themeTypography = theme.typography?.[type] ?? theme.typography?.['t']
        return `
            margin: 10px 0;
            font-size: 28px;
            text-align: start;
            color: ${color ?? 'rgb(0, 0, 0)'};
            overflow: ${lineClamp ? 'hidden' : ''};
            display: ${lineClamp ? '-webkit-box' : ''};
            -webkit-box-orient: ${lineClamp ? 'vertical' : ''};
            -webkit-line-clamp: ${lineClamp ? lineClamp : ''};
            ${hoverColor &&
            `&:hover {
                    color: ${theme.colors?.[hoverColor]};
                }`
            };
            text-transform: ${transform};
            ${style};

            @media (max-width: 1024px) {
                overflow: visible;
                display: block;
            }
        `
    }
    /* eslint-enable */
    const typoSwitch = (hType) => {
        switch (hType) {
            case 'h1':
                return (
                    <h1
                        className={clsx('typography h1', className)}
                        css={typoCss2}
                    >
                        {children}
                    </h1>
                )
            case 'h2':
                return (
                    <h2
                        className={clsx('typography h2', className)}
                        css={typoCss}
                    >
                        {children}
                    </h2>
                )
            case 'h3':
                return (
                    <h3
                        className={clsx('typography h3', className)}
                        css={typoCss}
                    >
                        {children}
                    </h3>
                )
            case 'h4':
                return (
                    <h4
                        className={clsx('typography h4', className)}
                        css={typoCss}
                    >
                        {children}
                    </h4>
                )
            case 'h5':
                return (
                    <h5
                        className={clsx('typography h5', className)}
                        css={typoCss}
                    >
                        {children}
                    </h5>
                )
            case 'h6':
                return (
                    <h6
                        className={clsx('typography h6', className)}
                        css={typoCss}
                    >
                        {children}
                    </h6>
                )
            case 'p':
                return (
                    <p
                        className={clsx('typography p', className)}
                        css={typoCss}
                    >
                        {children}
                    </p>
                )
            case 't':
                return (
                    <span
                        className={clsx('typography t', className)}
                        css={typoCss}
                    >
                        {children}
                    </span>
                )
            case 'div':
                return (
                    <div
                        className={clsx('typography', className)}
                        css={typoCss}
                    >
                        {children}
                    </div>
                )
        }
    }
    return typoSwitch(type)
}

export default Typography
